<template>
  <div>
    <!-- Modal Cambio Vehiculo-->
    <div
      class="modal fade"
      id="modal-form-mapa"
      style="background-color: #00000082"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Mapa Trazabilidad Vehículo</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
              @click="limpiar()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="btn-group float-right pl-2">
                <button
                  type="button"
                  class="btn btn-success btn-lg"
                  @click="generarListadoExcel()"
                >
                  <i class="far fa-file-excel"></i>
                </button>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col">
                <gmap-map
                  :center="center"
                  :zoom="zoomMapa"
                  style="width: 100%; height: 400px"
                  ref="map"
                >
                  <gmap-marker
                    :key="'m-' + index + '-' + (m.id || index)"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :icon="m.icon"
                    :clickable="true"
                    :draggable="false"
                    @click="
                      (center = m.position),
                        toggleInfoWindow(m.position, m.id, m.info)
                    "
                  ></gmap-marker>
                  <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen = false"
                  >
                    <div v-html="infoContent"></div>
                  </gmap-info-window>
                </gmap-map>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "VentanaOperacionesMapa",

  data() {
    return {
      viaje: null,
      fecha: null,
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      markers: [],
      path: [],
      currentPlace: null,
      coordenadasIniciales: {
        lat: 4.651371,
        lng: -74.071509,
      },
      center: {
        lat: 4.651371,
        lng: -74.071509,
      },
      zoomMapa: 12,
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      _onModalShown: null,
      _pendienteCargarTraza: false,
    };
  },

  methods: {
    getMapInstance() {
      const mapRef = this.$refs.map;
      if (!mapRef) return null;
      const map = mapRef.$mapObject;
      if (
        map &&
        typeof map.setCenter === "function" &&
        typeof map.setZoom === "function"
      ) {
        return map;
      }
      return null;
    },

    async esperarMapaListo(reintentos = 8) {
      for (let i = 0; i < reintentos; i++) {
        await this.$nextTick();
        const ref = this.$refs.map;
        if (ref && ref.$mapPromise) {
          try {
            await ref.$mapPromise;
          } catch (e) {
            // mapa aún no disponible
          }
        }
        const map = this.getMapInstance();
        if (map) {
          return map;
        }
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      return this.getMapInstance();
    },

    refrescarMapaVisible(center = null, zoom = null) {
      const map = this.getMapInstance();
      if (!map) return;
      // eslint-disable-next-line no-undef
      google.maps.event.trigger(map, "resize");
      if (center) {
        map.setCenter(center);
      } else {
        map.setCenter(this.center);
      }
      if (zoom != null) {
        map.setZoom(zoom);
      } else {
        map.setZoom(this.zoomMapa);
      }
    },

    centrarBogota() {
      this.center = {
        lat: this.coordenadasIniciales.lat,
        lng: this.coordenadasIniciales.lng,
      };
      this.zoomMapa = 12;
      this.refrescarMapaVisible(this.center, this.zoomMapa);
    },

    getTrazabilidad() {
      const vehiculoId = this.vehiculo_id;
      const fecha = this.fecha;
      axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/generarTrazabilidadMapa?vehiculo_id=" +
            vehiculoId +
            "&fecha=" +
            fecha
        )
        .then(async (response) => {
          if (this.vehiculo_id !== vehiculoId || this.fecha !== fecha) {
            return;
          }
          this.puntosTraza = Array.isArray(response.data) ? response.data : [];
          await this.trazaViaje();
        });
    },

    toggleInfoWindow: function (position, idx, ventana) {
      this.infoWindowPos = position;
      this.infoContent = ventana;

      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    async trazaViaje() {
      const map = await this.esperarMapaListo();
      if (!map) {
        return;
      }

      if (!this.puntosTraza.length) {
        this.centrarBogota();
        if (this.$refs.closeModal) {
          this.$refs.closeModal.click();
        }
        this.$swal({
          title: "Tramas no encontradas!",
          text: "No se encontraron tramas para este viaje",
          icon: "warning",
        });
        return;
      }

      const nuevosMarkers = [];
      for (let index = 0; index < this.puntosTraza.length; index++) {
        const punto = this.puntosTraza[index];
        nuevosMarkers.push({
          id: punto.id,
          position: {
            lat: parseFloat(punto.latitud),
            lng: parseFloat(punto.longitud),
          },
          icon: "/img/icon_punt_ruta.png",
          info: punto.ventana,
        });
      }

      this.puntoInicialLat = parseFloat(this.puntosTraza[0].latitud);
      this.puntoInicialLng = parseFloat(this.puntosTraza[0].longitud);
      this.infoPuntoInicial = this.puntosTraza[0].ventana;
      nuevosMarkers.push({
        id: this.puntosTraza[0].id,
        position: {
          lat: this.puntoInicialLat,
          lng: this.puntoInicialLng,
        },
        icon: "/img/icon_punto_g_ok.png",
        info: this.infoPuntoInicial,
      });

      this.puntofin = this.puntosTraza.slice(-1);
      this.puntoFinalLat = parseFloat(this.puntofin[0].latitud);
      this.puntoFinalLng = parseFloat(this.puntofin[0].longitud);
      this.infoPuntoFinal = this.puntofin[0].ventana;
      nuevosMarkers.push({
        id: this.puntofin[0].id,
        position: {
          lat: this.puntoFinalLat,
          lng: this.puntoFinalLng,
        },
        icon: "/img/icon_punto_g.png",
        info: this.infoPuntoFinal,
      });

      this.center = {
        lat: this.puntoInicialLat,
        lng: this.puntoInicialLng,
      };
      this.zoomMapa = 14;
      this.markers = nuevosMarkers;

      await this.$nextTick();
      this.refrescarMapaVisible(this.center, this.zoomMapa);
    },

    limpiar() {
      this.markers = [];
      this.puntosTraza = [];
      this.path = [];
      this.infoWinOpen = false;
      this.infoContent = "";
      this.currentMidx = null;
      this.puntoInicialLat = null;
      this.puntoInicialLng = null;
      this.puntoFinalLat = null;
      this.puntoFinalLng = null;
      this.infoPuntoFinal = "";
      this.infoPuntoInicial = "";
      this.puntofin = null;
      this.viaje = null;
      this.fecha = null;
      this.vehiculo_id = null;
      this._pendienteCargarTraza = false;
      this.center = {
        lat: this.coordenadasIniciales.lat,
        lng: this.coordenadasIniciales.lng,
      };
      this.zoomMapa = 12;
    },

    async llenar_modal_mapa(item, fecha) {
      this.limpiar();
      this.vehiculo_id = item.vehiculo_id;
      this.fecha = fecha.slice(0, 10);
      this.viaje = item;
      this._pendienteCargarTraza = true;
    },

    generarListadoExcel() {
      const viaje_id =
        (this.viaje && (this.viaje.id || this.viaje.viaje_id)) || null;
      if (!viaje_id) {
        this.$swal({
          icon: "warning",
          title: "No hay viaje seleccionado para exportar",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/trazaExport",
        data: { viaje_id },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          const mensaje =
            (e.response && e.response.data && e.response.data.mensaje) || e;
          this.$swal({
            icon: "error",
            title: "Ocurrio un error: " + mensaje,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  mounted() {
    this._onModalShown = async () => {
      await this.$nextTick();
      let map = await this.esperarMapaListo();
      this.refrescarMapaVisible(this.center, this.zoomMapa);

      const cargarSiPendiente = (mapaListo) => {
        if (this._pendienteCargarTraza && this.vehiculo_id && mapaListo) {
          this._pendienteCargarTraza = false;
          this.getTrazabilidad();
        }
      };

      if (map) {
        cargarSiPendiente(map);
      } else if (this._pendienteCargarTraza && this.vehiculo_id) {
        setTimeout(async () => {
          map = await this.esperarMapaListo();
          this.refrescarMapaVisible(this.center, this.zoomMapa);
          cargarSiPendiente(map);
        }, 250);
      }
    };

    if (window.$) {
      window.$("#modal-form-mapa").on("shown.bs.modal", this._onModalShown);
    } else {
      const modal = document.getElementById("modal-form-mapa");
      if (modal) {
        modal.addEventListener("shown.bs.modal", this._onModalShown);
      }
    }
  },

  beforeDestroy() {
    if (window.$ && this._onModalShown) {
      window.$("#modal-form-mapa").off("shown.bs.modal", this._onModalShown);
    } else {
      const modal = document.getElementById("modal-form-mapa");
      if (modal && this._onModalShown) {
        modal.removeEventListener("shown.bs.modal", this._onModalShown);
      }
    }
    this.limpiar();
  },
};
</script>
